/**
 * Using 3rd party react-datetime library for rendering calenders and clocks
 * Docs: [link](https://github.com/arqex/react-datetime/blob/2a83208452ac5e41c43fea31ef47c65efba0bb56/README.md)
 */

import { useFormikContext } from "formik"
import moment from "moment"
import React, { Fragment } from "react"
import DateTime from "react-datetime"
import "react-datetime/css/react-datetime.css"
import { DATE_FORMAT, TIME_FORMAT } from "../../../../utilities/constants.js"
import { getInNested } from "../dynamic-form.helper"

function InputDate(props) {
  const { id, label, name, placeholder, errorMessage, fieldData, isNestedFieldName, isRequired, ...otherProps } = props
  const { values, touched, errors, setFieldValue } = useFormikContext()

  // Disabling weekends from Calender
  const validDate = (current) => {
    const afterYesterday = current.isAfter(moment().subtract(1, "d"))
    return afterYesterday
  }

  // Handle dot-notation
  const normalizedNameKey = isNestedFieldName ? name : `['${name}']`

  // Native <input type="datetime-local"> variant (opt-in via fieldData.native).
  // Matches the flattened mock's mm/dd/yyyy, --:-- -- control. The value STORED in
  // the form stays in the exact same string the react-datetime picker produces
  // (`${DATE_FORMAT} ${TIME_FORMAT}`, e.g. "07-20-2026 2:30 pm"), so
  // setupParametersForScenarioFromGameDetailsValues parses it unchanged. The native
  // input needs ISO ("YYYY-MM-DDTHH:mm"), so we convert both directions with moment.
  // Empty input → empty start_date (preserves "start immediately").
  if (fieldData?.native) {
    const storedValue = getInNested(values, name, isNestedFieldName)
    const isoValue = storedValue ? moment(storedValue, `${DATE_FORMAT} ${TIME_FORMAT}`).format("YYYY-MM-DDTHH:mm") : ""
    const hasError = getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName)
    return (
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <label htmlFor={id} className="form-label">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <input
            type="datetime-local"
            id={id}
            name={name}
            className={`form-control form-control--datetime-local ${hasError ? "is-invalid" : ""}`}
            value={isoValue}
            onFocus={() => (touched[name] = true)}
            onChange={(e) => {
              const raw = e.target.value
              const formatted = raw ? moment(raw, "YYYY-MM-DDTHH:mm").format(`${DATE_FORMAT} ${TIME_FORMAT}`) : ""
              setFieldValue(normalizedNameKey, formatted)
            }}
          />
          {fieldData?.helper ? <div className="field-helper">{fieldData.helper}</div> : null}
          <div className="invalid-feedback">{hasError ? errorMessage : ""}</div>
        </div>
      </div>
    )
  }

  return (
    <Fragment>
      <div className="form-block-wrapper">
        <div className="custom-form-block flex-grow-1">
          <label htmlFor={id} className="form-label">
            {label} {isRequired && <sup>*</sup>}
          </label>
          <div className="input-group custom-field has-validation">
            <DateTime
              inputProps={{
                name,
                id,
                placeholder,
                className: `form-control ${
                  getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? "is-invalid" : ""
                }`,
                readOnly: true,
              }}
              closeOnSelect={true}
              closeOnClickOutside={true}
              dateFormat={DATE_FORMAT}
              timeFormat={TIME_FORMAT}
              isValidDate={validDate}
              value={getInNested(values, name, isNestedFieldName)}
              onOpen={() => (touched[name] = true)}
              onChange={(dateValue) => {
                setFieldValue(normalizedNameKey, moment(dateValue).format(`${DATE_FORMAT} ${TIME_FORMAT}`))
              }}
            />
            <span
              className="icon-wrapper input-field-icon clickable"
              onClick={() => {
                document.getElementById(id).click()
              }}
            >
              <i className="fa-solid fa-calendar-days"></i>
            </span>
          </div>
          {fieldData?.helper ? <div className="field-helper">{fieldData.helper}</div> : null}
          <div className={`invalid-feedback`}>
            {getInNested(touched, name, isNestedFieldName) && getInNested(errors, name, isNestedFieldName) ? errorMessage : ""}
          </div>
        </div>
      </div>
    </Fragment>
  )
}

InputDate.propTypes = {}

export default InputDate
